import React, { useState } from 'react'
import { Form, Button, Image } from "react-bootstrap"
import fooldali_icon from '../img/foldali_ikon.png';
import axios from "axios";



function Login() {


    const [formData, setFormData] = useState({
        username: "",
        password: "",
    })

    const [errorMessage, setErrorMessage] = useState("");

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    };


    const Login = (event) => {
        event.preventDefault();
        axios.post(process.env.REACT_APP_BASE_URL + '/api/login?code=' + process.env.REACT_APP_API_KEY, formData, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            console.log(res);
            console.log(res.data);
            sessionStorage.setItem("role", res.data.Role.toLowerCase());
            sessionStorage.setItem("sessionToken", res.data.SessionToken);
            sessionStorage.setItem("loggedUserId", res.data.RowId);
            sessionStorage.setItem("Name", res.data.Name);
            window.location = "/redirections"
        }).catch((error) => {
            if (error.response.status === 403) {
                setErrorMessage("Hibás felhasználónév jelszó páros.")
            }
            console.log(error)
        });
    }



    return (<div className="text-center" id="login">
        <Image src={fooldali_icon} alt="Főoldali átirányítás ikon" className='fooldali_icon' />
        <Form className="form-signin" onSubmit={Login}>
            <h1 className="h3 mb-3 font-weight-normal">Üdvözlünk!</h1>
            <p className='horizontal-center f-b'>Kérlek, jelentkezz be!</p>
            <Form.Group className="mb-3" controlId="UserNameorEmail">
                <Form.Label>Felhasználónév / Email cím</Form.Label>
                <Form.Control type="text" placeholder="Felhasználónév / Email cím" name="username" value={formData.username} onChange={handleChange} />
            </Form.Group>

            <Form.Group className="mb-3" controlId="Password">
                <Form.Label>Jelszó</Form.Label>
                <Form.Control type="password" placeholder="Jelszó" name="password" value={formData.password} onChange={handleChange} />
            </Form.Group>
            <Button variant="primary" type="submit" id="login">
                Bejelentkezés
            </Button>
            {errorMessage !== "" ? <p className="error">{errorMessage}</p> : ""}
        </Form>
    </div >
    )

}
export default Login;
